import apiClient from './api.service';

const RegistrationService = {
  // Get all registrations
  getAllRegistrations() {
    return apiClient.get('/registration');
  },

  // Get registration by ID
  getRegistrationById(id) {
    return apiClient.get(`/registration/${id}`);
  },

  // Get registrations by course
  getRegistrationsByCourse(courseId) {
    return apiClient.get(`/registration/byCourse/${courseId}`);
  },

  // Get registration statistics
  getRegistrationStats() {
    return apiClient.get('/registration/admin/stats');
  },

  // Enroll a user into a course (admin action)
  enrollUser(userId, courseId) {
    return apiClient.post('/registration/admin/add', { user_id: userId, course_id: courseId });
  },

  // Remove a user from a course (admin action)
  removeUser(userId, courseId) {
    return apiClient.post('/registration/admin/remove', { user_id: userId, course_id: courseId });
  }
};

export default RegistrationService;
